<template>
  <div
    class="flex h-screen overflow-hidden bg-gray-100">
    <div
      id="main-content"
      class="flex w-0 flex-1 flex-col overflow-hidden">
      <main
        class="relative flex-1 overflow-y-auto focus:outline-none"
        tabindex="0">
        <alerts />
        <slot />
      </main>
    </div>
  </div>
</template>

<script>

import Alerts from '@/Components/Alerts.vue';

export default {
  components: {
    Alerts,
  },

  data() {
    return {

    };
  },

  methods: {
  },
};
</script>
